<script lang="ts" setup>
import BaseSpinner from './BaseSpinner.vue'

defineProps<{
  isFetching: boolean
  isAutoReFetching: boolean
  isDone: boolean
}>()
</script>

<template>
  <div class="tw:min-h-[calc(100vh-3rem-1px)]">
    <Transition name="fade">
      <div
        v-if="!isDone && isFetching && !isAutoReFetching"
        data-test="loading"
      >
        <BaseSpinner
          class="tw:absolute tw:left-1/2 tw:top-1/2 tw:-mr-4 tw:-mt-4 tw:text-gray-600"
          size="medium"
        />
      </div>
      <slot v-else />
    </Transition>
    <slot name="out-of-transition" />
  </div>
</template>
